import { render, staticRenderFns } from "./dataApp.vue?vue&type=template&id=00be77a8&scoped=true"
import script from "./dataApp.vue?vue&type=script&lang=js"
export * from "./dataApp.vue?vue&type=script&lang=js"
import style0 from "./dataApp.vue?vue&type=style&index=0&id=00be77a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00be77a8",
  null
  
)

export default component.exports